export const DEFAULT_SPRINT_SEPARATOR = '.';
const SPRINTS_PER_YEAR = 26;

export function getSprintName(baseStartDate, sprintIndex, baseStartNumber, separator = DEFAULT_SPRINT_SEPARATOR) {
  const baseYear = baseStartDate.getFullYear();
  const normalizedBaseNumber = Math.min(Math.max(baseStartNumber, 1), SPRINTS_PER_YEAR);
  const zeroBasedIndex = normalizedBaseNumber - 1 + sprintIndex;
  const yearOffset = Math.floor(zeroBasedIndex / SPRINTS_PER_YEAR);
  const sprintNumber = (zeroBasedIndex % SPRINTS_PER_YEAR) + 1;
  const year = baseYear + yearOffset;

  return `${String(year).slice(2)}${separator}${sprintNumber}`;
}

export function getSprintPeriods(baseStartDate, startIndex, sprintCount = 8, baseStartNumber = 1, separator = DEFAULT_SPRINT_SEPARATOR) {
  const sprints = [];
  for (let i = 0; i < sprintCount; i++) {
    const sprintIndex = startIndex + i;
    const start = new Date(baseStartDate);
    start.setDate(start.getDate() + sprintIndex * 14);
    const end = new Date(start);
    end.setDate(end.getDate() + 13);
    const name = getSprintName(baseStartDate, sprintIndex, baseStartNumber, separator);
    sprints.push({ name, start, end });
  }
  return sprints;
}

export function getCurrentSprintIndex(startDate) {
  const now = new Date();
  const diffDays = Math.floor((now - startDate) / (1000 * 60 * 60 * 24));
  return Math.max(0, Math.floor(diffDays / 14));
}
